module.exports = __webpack_public_path__ + "img/refarral-new-2.da7330ff.png";